{
  "completed": "Abgeschlossen: ",
  "current": "Aktuell: ",
  "notCompleted": "Nicht abgeschlossen: ",
  "steplist": "Schrittliste"
}
